import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-network-receipt-printer' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

const CitizenReceiptPrinter = NativeModules.CitizenReceiptPrinter
  ? NativeModules.CitizenReceiptPrinter
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

const StarMicronicsReceiptPrinter = NativeModules.StarMicronicsReceiptPrinter
  ? NativeModules.StarMicronicsReceiptPrinter
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

const NetworkReceiptPrinter = NativeModules.NetworkReceiptPrinter
  ? NativeModules.NetworkReceiptPrinter
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

const NitaReceiptPrinter = NativeModules.NitaReceiptPrinter
  ? NativeModules.NitaReceiptPrinter
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

const ProwillReceiptPrinter = NativeModules.ProwillReceiptPrinter
  ? NativeModules.ProwillReceiptPrinter
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

const ProwillReceiptPrinterBitmap = NativeModules.ProwillReceiptPrinterBitmap
  ? NativeModules.ProwillReceiptPrinterBitmap
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );
// export function multiply(a: number, b: number): Promise<number> {
//   return NetworkReceiptPrinter.multiply(a, b);
// }

export function connectPrinter(printerIp: string, port: number): Promise<void> {
  return NetworkReceiptPrinter.connect(printerIp, port);
}

export function testPrintCitizen(input: {
  printerIp: string;
  orderType: string;
  sectionHeader: any;
  sectionItem: any;
  sectionFooter: any;
}): Promise<void> {
  return CitizenReceiptPrinter.printReceipt(input);
  //return NetworkReceiptPrinter.testPrint(input);
}

export function testPrintStarMicronics(input: {
  printerIp: string;
  orderType: string;
  sectionHeader: any;
  sectionItem: any;
  sectionFooter: any;
}): Promise<void> {
  return StarMicronicsReceiptPrinter.printReceipt(input);
  //return NetworkReceiptPrinter.testPrint(input);
}

export function testPrintStarMicronicsV2(input: {
  printerIp: string;
  orderType: string;
  sectionHeader: any;
  sectionItem: any;
  sectionSummary: any;
  sectionFooter: any;
}): Promise<void> {
  return StarMicronicsReceiptPrinter.printReceiptV2(input);
  //return NetworkReceiptPrinter.testPrint(input);
}

export function testOpenCashDrawer(input: {
  printerIp: string;
}): Promise<void> {
  return StarMicronicsReceiptPrinter.openCashDrawer(input);
  //return NetworkReceiptPrinter.testPrint(input);
}

export function testPrintNita(input: {
  printerIp: string;
  orderType: string;
  sectionHeader: any;
  sectionItem: any;
  sectionFooter: any;
}): Promise<void> {
  return NitaReceiptPrinter.printReceipt(input);
  //return NetworkReceiptPrinter.testPrint(input);
}

export function testPrintProwill(input: {
  printerIp: string;
  orderType: string;
  sectionHeader: any;
  sectionItem: any;
  sectionFooter: any;
}): Promise<void> {
  return ProwillReceiptPrinter.printReceipt(input);
  //return NetworkReceiptPrinter.testPrint(input);
}

export function testPrintProwillBitmap(input: {
  printerIp: string;
  orderType: string;
  sectionHeader: any;
  sectionItem: any;
  sectionFooter: any;
}): Promise<void> {
  return ProwillReceiptPrinterBitmap.printReceipt(input);
}

export function testPrintCitizenV2(input: {
  printerIp: string;
  orderType: string;
  sectionHeader: any;
  sectionItem: any;
  sectionSummary: any;
  sectionFooter: any;
}): Promise<void> {
  return CitizenReceiptPrinter.printReceiptV2(input);
  //return NetworkReceiptPrinter.testPrint(input);
}
